import React, { useCallback } from "react";

import { Descendant, Editor, Transforms } from "slate";
import { useSlate } from "slate-react";

import ElementType from "../../../type/slate/ElementType";

import LinkModal from "./LinkModal";

interface LinkCreateProps {
  onHide?: () => void;
}

const LinkCreate = ({ onHide }: LinkCreateProps) => {
  const editor = useSlate();

  const handleCreate = useCallback(
    (text: string, url: string) => {
      const linkNode: Descendant[] = [
        {
          children: [{ text }],
          type: ElementType.LINK,
          url,
        },
      ];

      Transforms.insertNodes(editor, linkNode);

      onHide?.();
    },
    [onHide, editor]
  );

  return (
    <LinkModal
      initialText={editor.selection ? Editor.string(editor, editor.selection) : ""}
      onHide={onHide}
      onOk={handleCreate}
    />
  );
};

export default LinkCreate;
